import IntlMessageFormat from "intl-messageformat";

const formatterCache = new Map<string, IntlMessageFormat>();

export type TranslateValues = Record<string, string | number | boolean | Date | null | undefined>;

export function formatMessage(
  locale: string,
  key: string,
  message: string,
  values?: TranslateValues,
): string {
  if (!values || Object.keys(values).length === 0) {
    // Fast path: no ICU needed for plain strings without braces
    if (!message.includes("{")) return message;
  }
  const cacheKey = `${locale}::${key}::${message}`;
  let formatter = formatterCache.get(cacheKey);
  if (!formatter) {
    try {
      formatter = new IntlMessageFormat(message, locale);
      formatterCache.set(cacheKey, formatter);
    } catch {
      return message;
    }
  }
  try {
    return String(formatter.format(values as Record<string, unknown>));
  } catch {
    return message;
  }
}

export function clearMessageFormatCache(): void {
  formatterCache.clear();
}
